import { render } from "./uploadtest.vue?vue&type=template&id=3e418a7e"
import script from "./uploadtest.vue?vue&type=script&lang=js"
export * from "./uploadtest.vue?vue&type=script&lang=js"

import "./uploadtest.vue?vue&type=style&index=0&id=3e418a7e&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__